import type {
    AuditMaterialStatus,
    ImageMaterial,
    PreviewMode,
    Storyboard,
    VideoMaterial,
} from '@/services/storyboardService/interface';
import {
    AuditMaterialStatusValue,
    PREVIEW_STATUS_PRIORITY,
    PreviewModeValue,
} from '@/services/storyboardService/interface';

/** 按 sortOrder 升序排序分镜 */
export const sortStoryboardsBySortOrder = (storyboards?: Storyboard[] | null): Storyboard[] =>
    [...(storyboards ?? [])].sort((a, b) => a.sortOrder - b.sortOrder);

type SortableMaterial = ImageMaterial | VideoMaterial;

const rank = (status?: AuditMaterialStatus): number => {
    const index = PREVIEW_STATUS_PRIORITY.indexOf(
        (status ?? AuditMaterialStatusValue.Unreviewed) as (typeof PREVIEW_STATUS_PRIORITY)[number],
    );
    return index < 0 ? PREVIEW_STATUS_PRIORITY.length : index;
};

/** 缩略图展示顺序：状态优先级高于提交时间；同状态内 materialId 大者为最新提交，排在前 */
export const sortMaterialsByAudit = <T extends SortableMaterial>(list: T[]): T[] =>
    [...list].sort((a, b) => {
        const rankA = rank(a.remarkStatus);
        const rankB = rank(b.remarkStatus);
        return rankA === rankB ? b.materialId - a.materialId : rankA - rankB;
    });

/** 按模式挑出该分镜在当前 tab 下应播放的素材，挑不出返回 undefined */
export const pickPreviewMaterial = (
    storyboard: Storyboard,
    tab: 'image' | 'video',
    mode: PreviewMode,
): SortableMaterial | undefined => {
    const list: SortableMaterial[] =
        (tab === 'image' ? storyboard.imageMaterials : storyboard.videoMaterials) ?? [];
    const sorted = sortMaterialsByAudit(list.filter((material) => !!material.url));
    return mode === PreviewModeValue.OnlyPassed
        ? sorted.find((material) => material.remarkStatus === AuditMaterialStatusValue.Passed)
        : sorted[0];
};
